import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["secondary", "className"],
  _excluded2 = ["onEdit", "onPublish", "disabled", "className"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { CheckOutlined, EditOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import DixuButton from "../DixuButton/DixuButton";
import React from 'react';
const DixuListingPublishControlsButton = _ref => {
  let {
      secondary,
      className
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const classes = classNames('dixu-listing-publish-controls__button', {
    'dixu-listing-publish-controls__button--secondary': secondary
  }, className);
  return /*#__PURE__*/React.createElement(DixuButton, _objectSpread({
    className: classes,
    type: 'primary',
    size: 'lg',
    shadow: '3',
    justify: 'start',
    weight: 'bold'
  }, rest));
};
DixuListingPublishControlsButton.defaultProps = {};
const DixuListingPublishControls = _ref2 => {
  let {
      onEdit,
      onPublish,
      disabled,
      className
    } = _ref2,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  const classes = classNames('dixu-listing-publish-controls');
  return /*#__PURE__*/React.createElement("div", _objectSpread({
    className: classes
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: "dixu-listing-publish-controls__buttons"
  }, /*#__PURE__*/React.createElement(DixuListingPublishControlsButton, {
    icon: /*#__PURE__*/React.createElement(EditOutlined, null),
    onClick: onEdit,
    disabled: disabled,
    secondary: true
  }, "Muokkaa"), /*#__PURE__*/React.createElement(DixuListingPublishControlsButton, {
    icon: /*#__PURE__*/React.createElement(CheckOutlined, null),
    onClick: onPublish,
    disabled: disabled
  }, "Julkaise")));
};
DixuListingPublishControls.defaultProps = {
  onEdit: undefined,
  onPublish: undefined,
  disabled: false
};
export default DixuListingPublishControls;